import { useEffect, useState } from 'react';
import axios from 'axios';

export default function useFeatureUsageData({
  interval  = 'daily',
  startDate,
  endDate
}) {
  const [users,    setUsers]    = useState([]);
  const [features, setFeatures] = useState([]);
  const [periods,  setPeriods]  = useState([]);
  const [dataByUser, setDataByUser] = useState({});
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    const fetchUsage = async () => {
      setLoading(true);

      try {
        const sessionID = localStorage.getItem('sessionId');
        const authToken = localStorage.getItem('authToken');
        const params    = { interval };
        if (startDate) params.start = startDate;
        if (endDate)   params.end   = endDate;

        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/analytics/feature-usage`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              'x-session-id': sessionID,
            },
            params,
          }
        );

        setUsers(data.users);
        setFeatures(data.features);
        setPeriods(data.periods);
        setDataByUser(data.dataByUser);
      } catch (err) {
        console.error('Failed to load feature usage', err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsage();
  }, [interval, startDate, endDate]);

  return { users, features, periods, dataByUser, loading };
}